import styled from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesTextArea,
    styledInteraction,
} from '@pkg/primitives';

import { tokens as editIconTokens } from '../EditIcon/EditIcon.tokens';

import { baseTextStyles, baseWrapperStyles, textElementStyles, tokens } from './UserName.tokens';

export const StyledUserName = styled.div`
    display: grid;
    justify-items: start;
    max-width: calc(100% - ${editIconTokens.size + editIconTokens.offset}px);
`;

export const TextAreaWrapper = styled.div`
    ${baseWrapperStyles};
    position: relative;
    margin-top: ${tokens.padding.top * -1}px;
    margin-bottom: ${tokens.padding.rest * -1}px;
    margin-left: ${tokens.padding.rest * -1}px;
    margin-right: ${tokens.padding.rest * -1}px;

    @media (min-width: 768px) {
        display: grid;
    }

    textarea {
        ${baseTextStyles};
        ${recipesTextArea.basic};
        cursor: pointer;
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        background-color: rgb(255, 255, 255, 0);
        border-radius: ${tokens.radius}px;

        &::placeholder {
            color: rgb(255, 255, 255, 0.4);
            opacity: 1;
        }

        &:focus {
            background-color: rgb(255, 255, 255, 0.06);
        }

        &:focus,
        &[disabled],
        &[readOnly] {
            cursor: unset;
        }

        &[disabled],
        &[readOnly] {
            background-color: transparent;
        }

        &[data-input-error]:focus-visible {
            outline-color: ${designColor.red};
        }
    }
`;

export const MirrorText = styled.span`
    ${textElementStyles};
    ${styledInteraction.interactionDisable};

    position: relative;
    z-index: 1;
    display: block;
    color: transparent;
    opacity: 0.8;
    transition: opacity ${duration.normal}ms ${easing.cubic};

    ${TextAreaWrapper} textarea:hover + & {
        opacity: 1;
    }

    ${TextAreaWrapper} textarea:focus + &,
    ${TextAreaWrapper} textarea:placeholder-shown + & {
        opacity: 0;
    }
`;

export const StaticLabel = styled.p`
    ${baseWrapperStyles};
    ${textElementStyles};
    padding: 0;
`;
